module.exports = __webpack_public_path__ + "static/media/picture.ffa956f4.jpg";